import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import { Link, IconSVG, Button, BackgroundImage } from 'components';
import { data } from './logic.js';
import './Instagram.scss';

const Instagram = () => (
  <StaticQuery
    query={graphql`
      fragment CareerInstagram on File {
        childImageSharp {
          fluid(maxWidth: 650) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }

      query {
        InstaKozi: file(relativePath: { eq: "career/instagram_kozi.jpg" }) {
          ...CareerInstagram
        }
        InstaDonuts: file(
          relativePath: { eq: "career/instagram_donuts.jpg" }
        ) {
          ...CareerInstagram
        }
        InstaTesters: file(
          relativePath: { eq: "career/instagram_testers.jpg" }
        ) {
          ...CareerInstagram
        }
        InstaWebsummit: file(
          relativePath: { eq: "career/instagram_websummit.jpg" }
        ) {
          ...CareerInstagram
        }
        InstaSilence: file(
          relativePath: { eq: "career/instagram_silence.jpg" }
        ) {
          ...CareerInstagram
        }
        InstaChaos: file(relativePath: { eq: "career/instagram_chaos.jpg" }) {
          ...CareerInstagram
        }
      }
    `}
    render={loadedData => (
      <LazyLoad once offset={200}>
        <div className={'instagram__container'}>
          {data.map((item, index) => (
            <Link
              to={item.link}
              id={`career-instagram-${index}`}
              key={item.image}
            >
              <BackgroundImage
                src={loadedData[item.image].childImageSharp.fluid}
              />
              <div className={'instagram--hover'}>
                <Button transparent color={'white'}>
                  <IconSVG name={'instagram'} size={'medium'} color={'white'} />
                </Button>
              </div>
            </Link>
          ))}
        </div>
      </LazyLoad>
    )}
  />
);

export default Instagram;
